import moment from "moment";
import { RootState } from "../reducers";
import { createSelector } from "reselect";

export const adminSelector = (state: RootState) => state.adminReducer;

export const initDataLoadingSelector = (state: RootState) =>
  adminSelector(state).initDataLoading;
export const citiesSelector = (state: RootState) => adminSelector(state).cities;
export const communitiesSelector = (state: RootState) =>
  adminSelector(state).communities;
export const languagesSelector = (state: RootState) =>
  adminSelector(state).languages;
export const additionalProgramsSelector = (state: RootState) =>
  adminSelector(state).additionalPrograms;
export const errorSelector = (state: RootState) => adminSelector(state).error;
export const newWitnessIdSelector = (state: RootState) =>
  adminSelector(state).newWitnessId;
export const duplicateWitnessNamesSelector = (state: RootState) =>
  adminSelector(state).duplicateWitnessNames;
export const volunteerListSelector = (state: RootState) =>
  adminSelector(state).volunteerList;
export const salondaysSelector = (state: RootState) =>
  adminSelector(state).salondays;
export const userCitySelector = (state: RootState) =>
  adminSelector(state).userCity;
export const numOfActiveFiltersSelector = (state: RootState) =>
  adminSelector(state).numOfActiveFilters;
export const hostSalonTrainingSelector = (state: RootState) =>
  adminSelector(state).hostSalonTraining;

const adjustDefaultSalonDate = (defaultSalonDate: Date, futureSalonDaysDates: Date[], today: Date): Date | null => {
  const currentTime = new Date();
  let finalDate = defaultSalonDate;
  const isTodayAndAfterSevenPM = defaultSalonDate.toDateString() === today.toDateString() && currentTime.getHours() >= 19

  if (isTodayAndAfterSevenPM) {
    finalDate = futureSalonDaysDates[1] || null;
  }

  if (finalDate) {
    finalDate.setHours(19, 0, 0, 0);
  }

  return finalDate;
};

export const salonDatesSelector = createSelector(
  salondaysSelector,
  (salonDays) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Remove time part for comparison

    // Convert salon days to Date objects and filter future dates (including today)
    const futureSalonDaysDates = salonDays
      .map(({ date }) => new Date(date))
      .filter((date) => date >= today)
      .sort((a, b) => a.getTime() - b.getTime());

    // Find the first default salon day in the future
    const defaultFutureSalonDayDate = salonDays
      .filter(({ default_for_year }) => default_for_year)
      .map(({ date }) => new Date(date))
      .find((date) => date >= today);

    const todayInFutureSalonDays = futureSalonDaysDates.find(
      (date) => date.toDateString() === today.toDateString()
    );

    let defaultSalonDate = todayInFutureSalonDays || defaultFutureSalonDayDate || futureSalonDaysDates[0] || null;

    defaultSalonDate = defaultSalonDate 
      ? adjustDefaultSalonDate(defaultSalonDate, futureSalonDaysDates, today) 
      : null;

    return {
      salonDays: futureSalonDaysDates,
      defaultSalonDate,
    };
  }
);